module.exports = __webpack_public_path__ + "img/the-rugby-company-product.d7b289a7.jpg";